/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from "react";
import { AddAPhotoOutlined } from "@mui/icons-material";
import { MDBContainer } from "mdb-react-ui-kit";
import { Link, useNavigate } from "react-router-dom";
import { PageLayout } from "../../../components/restaurant-portal/PageLayout";
import {
  useCreateMealMutation,
  useGetMealsCategoriesQuery,
  useUploadMealImageMutation,
} from "../../../features/services/restaurant/service";
import { toast } from "react-toastify";
import { FormControl, TextField } from "@mui/material";
import Loader from "../../../components/loader";
import axios from "axios";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";

export const RestaurantAddMenu = () => {
  const hiddenFileInput = useRef<HTMLInputElement | null>(null);
  const [uploadedImage, setUploadedImage] = useState("");
  const [name, setName] = useState("");
  const [price, setPrice] = useState<string>("");
  const [takeAwayPrice, setTakeAwayPrice] = useState<string>("");
  const [description, setDescription] = useState("");
  const [withTakeAway, setWithTakeAway] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedImage, setSelectedImage] = useState<string | any>(null);
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);

  //////////////////////////////////////////////
  // All Queries and mutations
  const [uploadMealImage, { uploadStatus, isUploadingImg, errorUploadingImg }] =
    useUploadMealImageMutation({
      selectFromResult: ({ data, isLoading, error }) => ({
        uploadStatus: data,
        isUploadingImg: isLoading,
        errorUploadingImg: error,
      }),
    });

  const {
    data: categories,
    isLoading: loading_categories,
    error: error_fetching_categories,
  } = useGetMealsCategoriesQuery();

  const [
    createMeal,
    {
      data: createMealSuccess,
      isLoading: creating_meal,
      error: error_creatingMeal,
    },
  ] = useCreateMealMutation();

  //////////////////////////////////////////////
  ///Functions
  const showFileInput = () => hiddenFileInput.current?.click();

  // to firstly upload image to cloudinary
  const authToken = sessionStorage.getItem("token");

  ///////////////////////////////// To upload Image to cloudinary
  const handleUpload = () => {
    setUploading(true);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/image-upload`,
        { image: selectedImage },
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      )
      .then((res: any) => {
        console.log("Image uploaded successfully", res);
        setUploading(false);
        setUploadedImage(res?.data?.url);
        toast.success("Image uploaded successfully");
      })
      .catch((err) => {
        console.log(err);
        setUploading(false);
        toast.error(err);
      });
  };

  ////////////////////////// To preview image

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (name && price && selectedCategory && uploadedImage) {
      createMeal({
        name,
        price: {
          amount: Number(price),
          currency_code: "NGN",
        },
        description,
        image_url: uploadedImage,
        meal_category: selectedCategory,
        is_in_stock: true,
        take_away_price: Number(takeAwayPrice),
        with_take_away: withTakeAway,
      });
    } else {
      toast.error("All input fields are required");
    }
  };

  //////////////////////////////////////////////

  /// useEffects
  useEffect(() => {
    if (selectedImage) {
      handleUpload();
    }
  }, [selectedImage]);

  useEffect(() => {
    setUploadedImage(uploadStatus?.url);
  }, [uploadStatus, errorUploadingImg]);

  useEffect(() => {
    if (createMealSuccess) {
      toast.success("Meal added successfully");
      navigate("/restaurant-portal/menu-manager");
    }
    if (
      error_creatingMeal &&
      typeof error_creatingMeal === "object" &&
      "status" in error_creatingMeal
    ) {
      const errorData = (error_creatingMeal as FetchBaseQueryError).data as {
        error?: string;
      };
      toast.error(errorData?.error || "Error creating meal");
    }
  }, [createMealSuccess, error_creatingMeal]);

  return (
    <PageLayout>
      <MDBContainer fluid={true} breakpoint="md" className="add-menu-container">
        <h1 style={{ fontSize: "20px" }}>
          <Link to="/restaurant-portal/menu-manager" style={{ color: "black" }}>
            &larr; &nbsp;
          </Link>
          Add New Meal
        </h1>
        <section>
          <form onSubmit={handleSubmit}>
            <div className="photo-upload">
              {!uploadedImage && !uploading ? (
                <AddAPhotoOutlined fontSize="large" onClick={showFileInput} />
              ) : !uploadedImage && uploading ? (
                <Loader
                  height="27px"
                  width="27px"
                  borderTopColor="#FFAE0A"
                  borderTopWidth="5px"
                  borderWidth="5px"
                />
              ) : (
                <img
                  src={uploadedImage}
                  alt=""
                  width="100%"
                  height="250px"
                  onClick={showFileInput}
                />
              )}
            </div>
            <div className="label-texts">
              <p className="first">
                This image will be displayed to the customers
              </p>
              <p className="second">It's recommended to upload quality image</p>
            </div>
            <input
              type="file"
              className="hidden-input"
              ref={hiddenFileInput}
              accept="image/*"
              //comment back to return initial functionalities
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                e.target?.files && setSelectedImage(e.target?.files[0])
              }

              // onChange={(event: any) => handleImageChange(event)}
            />
            <div className="inputs-container">
              <FormControl fullWidth style={{ marginBottom: "1.3rem" }}>
                <TextField
                  label="Meal name"
                  id="mealName"
                  type="text"
                  onChange={(e) => setName(e.target.value.trim().toLowerCase())}
                  value={name}
                />
              </FormControl>

              <FormControl fullWidth style={{ marginBottom: "1.3rem" }}>
                <TextField
                  label="Price"
                  id="price"
                  type="number"
                  onChange={(e) => {
                    const value = e.target.value;
                    setPrice(value === "0" ? "" : value);
                  }}
                  value={price}
                  // inputProps={{ min: "0" }}
                />
              </FormControl>
              <br />

              <select
                className="w-100 shadow-0 drop-down-select"
                style={{ paddingTop: "16px", paddingBottom: "16px" }}
                value={selectedCategory}
                onChange={(e) =>
                  setSelectedCategory(e.target.value.toLowerCase())
                }
              >
                <option value="">
                  {loading_categories && !error_fetching_categories
                    ? "Loading..."
                    : "Select Category"}
                </option>
                {/*  replace type any with categories type */}
                {categories?.map((item: any) => (
                  <option key={item?._id} value={item?.name.toLowerCase()}>
                    {item?.name}
                  </option>
                ))}
              </select>

              <p style={{ fontSize: "13px", marginTop: "-25px" }}>
                <a href="/meal-categories" target="_blank">
                  How do I know a meal category
                </a>
              </p>
              <FormControl fullWidth style={{ marginBottom: "1.3rem" }}>
                <TextField
                  label="Take away price"
                  id="takeaway"
                  type="number"
                  onChange={(e) => {
                    const value = e.target.value;
                    setTakeAwayPrice(value === "0" ? "" : value);
                  }}
                  value={takeAwayPrice}
                  // inputProps={{ min: "0" }}
                />
              </FormControl>
              <br />
              <div className="take-away">
                <input
                  type="checkbox"
                  checked={withTakeAway}
                  onChange={() => setWithTakeAway(!withTakeAway)}
                />
                <label>With take away</label>
              </div>
              <br />
              <FormControl
                fullWidth
                style={{ marginTop: "1.3rem", marginBottom: "1.3rem" }}
              >
                <TextField
                  label="Description"
                  id="description"
                  className="text-area"
                  multiline
                  rows={5}
                  onChange={(e) =>
                    setDescription(e.target.value.trim().toLowerCase())
                  }
                  value={description}
                  // inputProps={{
                  //   style: { cursor: "text" },
                  // }}
                />
              </FormControl>

              <button className="w-100 save-button" type="submit">
                {creating_meal ? (
                  <Loader
                    height="27px"
                    width="27px"
                    borderTopColor="#FFAE0A"
                    borderTopWidth="5px"
                    borderWidth="5px"
                  />
                ) : (
                  "ADD ITEM"
                )}
              </button>
            </div>
          </form>
        </section>
      </MDBContainer>
    </PageLayout>
  );
};
